import Image from 'components/Shared/Image';
import styles from './styles.scss';
import ResponsiveImage from 'components/Shared/Image/ResponsiveImage';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import cn from 'classnames';
import { ImageProps } from './types';

const MOBILE_WIDTH = 250;
const DESKTOP_WIDTH = 500;

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

const responsive: ResponsiveImage = {
  srcSet: Object.values(sizes),
  sizes: `(max-width: 768px) ${sizes.default.viewWidth}px,
  ${sizes.medium.viewWidth}px`
};

const SIZE = {
  height: 124,
  width: 164
};

const TO_PERCENTAGE = 100;

interface StaticImageProps extends Pick<ImageProps, 'path'> {
  className?: string;
}

const StaticImage = ({ path, className }: StaticImageProps) => (
  <div
    style={{ paddingBottom: `${(SIZE.height / SIZE.width) * TO_PERCENTAGE}%` }}
    className={styles.staticContainer}
  >
    <img src={path} className={cn(className, styles.static)} />
  </div>
);

export const ImageContainer = ({ path, image }: ImageProps) => {
  if (path) {
    return <StaticImage path={path} className={styles.image} />;
  }

  return (
    <Image
      height={SIZE.height}
      width={SIZE.width}
      className={styles.image}
      responsive={responsive}
      wrapperStyle={{ width: '100%' }}
      paddingBottom
      {...image}
      alt={image?.alt}
    />
  );
};
